import React from 'react';
import { Table } from 'antd';
import './TableAl.css'; // Import your CSS file for custom styles

const TableAl = ({ columnnn, isLoadinggg, dataaa, pagination, onPageSizeChange }) => {
  return (
    <div className="table-container">
      
      <Table
        columns={columnnn}
        dataSource={dataaa}
        loading={isLoadinggg}
        pagination={{
          style: {
            position: 'fixed',
            bottom: 0,
            right: 0,
            backgroundColor: 'white',
            zIndex: 1000,
          },
          showSizeChanger: true, // Enable size changer
          pageSizeOptions: ['5','10', '20', '40'],
          current: pagination?.current, // Current page
          pageSize: pagination?.pageSize, // Page size
          total: pagination?.total, // Total number of items
          onChange: pagination?.onChange, // Function to handle page changes
          position: ['topRight'], // Position pagination at the bottom right
        }}
        rowKey="_id" // Assuming each row has a unique key
      />
    </div>
  );
};

export default TableAl;